function Cost() {
  return (
    <div className="cost section">
      <h2 className="title">
        <img src="images/yodogawa-6.png" alt="参加費" />
      </h2>
      <p className="emp">無料</p>
      <p className="hosoku">（一部のみの参加も可能）</p>
      <div className="art">
        <img src="images/art-1.png" alt="" />
      </div>
    </div>
  );
}

export default Cost;
